import "index.css";

// Import all JavaScript & CSS files from src/_components
// import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}";

console.info("💖", "This is the only first-party javascript on this site.");
